import { Award, BadgeCheck, Clock, Heart, MapPin, ShieldCheck, Truck, Users } from 'lucide-react';

const features = [
  {
    icon: Clock,
    title: '30+ Years of Trust',
    description: 'Family-run business serving Delhi since 1992 with dedication and integrity.',
  },
  {
    icon: BadgeCheck,
    title: '100% Genuine Products',
    description: 'Deals In Sleepwell, King Koil, Kurlon, and other premium brands.',
  },
  {
    icon: Award,
    title: 'Best Prices Guaranteed',
    description: 'Competitive pricing with no hidden costs. Value for every rupee spent.',
  },
  {
    icon: Users,
    title: 'Personalized Service',
    description: 'Expert guidance to help you choose the perfect mattress for your needs.',
  },
  {
    icon: Truck,
    title: 'Free Local Delivery',
    description: 'Complimentary delivery within Delhi NCR on all major purchases.',
  },
  {
    icon: Heart,
    title: 'Customer Satisfaction',
    description: '4.5 star Google rating from thousands of happy customers.',
  },
];

export const WhyChooseUs = () => {
  return (
    <section 
      data-testid="why-choose-us-section"
      className="py-16 md:py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-sm font-medium tracking-widest uppercase text-teal-700 mb-3">
            Why Aggarwal Foam Palace
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            Your Comfort, Our Priority
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Discover why families across Delhi have trusted us for over three decades
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              data-testid={`feature-card-${index}`}
              className="group relative bg-stone-50 hover:bg-white rounded-2xl p-6 md:p-8 transition-all duration-300 hover:shadow-xl border border-transparent hover:border-stone-100"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-teal-100 group-hover:bg-teal-600 rounded-2xl flex items-center justify-center mb-5 transition-colors duration-300">
                <feature.icon className="w-7 h-7 text-teal-600 group-hover:text-white transition-colors duration-300" />
              </div>
              
              {/* Content */}
              <h3 className="text-xl font-bold text-stone-800 mb-3">
                {feature.title}
              </h3>
              <p className="text-stone-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-16 bg-gradient-to-r from-teal-600 to-teal-700 rounded-3xl p-8 md:p-12 text-center text-white relative overflow-hidden">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2" />
          
          <div className="relative z-10">
            <div className="flex items-center justify-center gap-2 mb-4">
              <MapPin className="w-5 h-5" />
              <span className="font-medium">Visit Our Store</span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-4">
              Shop No. 72/5, Yusuf Sarai Market, New Delhi
            </h3>
            <p className="text-teal-100 mb-6 text-lg">
              Open Daily: 10:30 AM - 9:30 PM | Call: +91 99712 31812
            </p>
            <a 
              href="https://maps.app.goo.gl/tLGnG1nKfKTFJZHaA"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-get-directions"
              className="inline-flex items-center gap-2 bg-white text-teal-700 px-8 py-4 rounded-full font-semibold hover:bg-stone-100 transition-colors"
            >
              Get Directions
              <MapPin className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
